const r = {
  defaultProps: {
    variant: "circular",
    color: "primary"
  },
  styleOverrides: {
    root: ({ theme: e }) => ({
      gap: "0.5rem",
      borderRadius: "6.25rem",
      fontSize: "1rem",
      "&.Mui-disabled": {
        boxShadow: e.shadows[5]
      },
      variants: [
        {
          props: {
            size: "large"
          },
          style: {
            fontSize: "1.125rem",
            minHeight: "56px"
          }
        },
        {
          props: {
            size: "medium"
          },
          style: {
            minHeight: "48px"
          }
        },
        {
          props: {
            size: "small"
          },
          style: {
            minHeight: "40px"
          }
        }
      ]
    })
  }
};
export {
  r as default
};
